import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'
import { DataGrid, DataGridSortOrder } from "../../components/ui/DataGrid";
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';
import { checkBox, IAvidCheckTracker } from '../ActionAlertsReportsContainer/interfaces';
import { alertDetails } from '../MyAlertsContainer/interfaces';
import { getBulkCustomerInfo } from '../MyAlertsContainer/lib/http';
import {
  compareCustomerName, compareCustomerNameOnReport,
  getListOfIndividualSurveyIdsFromReport,
  resolveCustomerName, resolveCustomerNameOnReport
} from '../MyAlertsContainer/lib/utils';
import { ReportsFilersBar } from "./filtersBar";
import { HttpRequest } from "util/http";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle, FormGroup, Input, Label,
} from 'reactstrap';
import { ActionAlertFormContainer } from "../ActionAlertFormContainer";
import ExportChart from "../ActionAlertsReportsContainer/lib/export";
import { RadioGroup } from "../../components/ui/RadioGroup";
import { Popover } from "../../components/ui/Popover";
import * as _ from 'lodash';
import { userData } from "../../util/userData";

interface hierarchyFilter {
  trail: Avid[]
  current: Avid
  children: Avid[]
}

interface Avid {
  id: number
  label: string
  prevLink: string
  nextLink: string
  hierarchyLevel: string
  defaultUser: number
  customer: string
  childCount: number
  childAvids?: Avid[]
  defaultAssignee: number
  defaultAssigneeRecordID?: number
}

interface hierPath {
  avid: string
  path: string[]
}
interface containerProps {

}

interface chartOptions {
  dropdownOpen: boolean
  orderBy: 'value' | 'label'
  orderByValue: 'ascending' | 'descending'
  orderByValueOptions: checkBox[]
}

interface containerState {
  filters: activeFiltersSet
  records: actionAlert[]
  filteredRecords: actionAlert[]
  series: Series
  pieChartOptions: Highcharts.Options
  trendGraphOptions: Highcharts.Options
  barGraphOptions: Highcharts.Options
  avgTimetoResolution: number
  recordsLoading: boolean
  trendGrpahLoading: boolean
  barGrpahLoading: boolean
  pieChartLoading: boolean
  sortBy: keyof actionAlert
  sortOrder: DataGridSortOrder
  reportExpanded: string
  assigneeChartRef?: any
  trendChartRef?: any
  actionAlertFormOpen: boolean
  selectedAlertID: number
  dictAvidPaths: Set<hierPath>
  pieChartData: Array<any>
  agingData: Array<any>
  isPieChartExportDropdownOpen: boolean
  isBarChartExportDropdownOpen: boolean
  chartBarOptions: chartOptions
  hiddenProperties: string[]
  AvidList: IAvidCheckTracker[]
  filteredAvidList: string[]
  userId: number
  customerInfoList: any[]
}

export interface actionAlert {
  id: number
  createdDate: string
  resolvedDate: string
  assignedTo: string
  assignedToId?: number
  src: string
  actionItemReason: string
  actionItemStatus: string
  rootCause: string
  severityLabel: string
  severityColor: string
  resolved?: boolean
  timeToResolution?: number
  Quarter: number
  month: number
  year: number
  avid?: string
  label: string
  itemsResolved: number
  sum: number
  result: number
  status: string
  Username: string
  age: string
  ageAsNumber: number
  individualSurveyId?: number
  customerName?: string
}

interface activeFiltersSet {
  reasonFilters: { isFiltered: boolean, filteredList: string[], defaultList: string[] }
  rootCauseFilters: { isFiltered: boolean, filteredList: string[], defaultList: string[] }
  severityFilters: { isFiltered: boolean, filteredList: string[], defaultList: string[] }
  sourceFilters: { isFiltered: boolean, filteredList: string[], defaultList: string[] }
  teamFilters: { isFiltered: boolean, filteredList: string[], defaultList: string[] }
  trendActiveFilter: string
  hierFilter: hierarchyFilter
  AvidsList: IAvidCheckTracker[]
}
interface DateRange {
  startOfdateRange: Date
  endOfdateRange: Date
  period: string
}
interface Series {
  byMonth: Average[];
  byQuarter: Average[];
  byYear: Average[];
  byAssignee: Average[];
}

interface Average {
  label: string
  itemsResolved: number
  sum: number
  result: number
}

interface Assignee {
  username: string
  avgObj: Average
}

export class ActionAlertsAgingReportsContainer extends React.Component<containerProps, containerState> {
  state: containerState = {
    filters: undefined,
    records: [],
    filteredRecords: [],
    series: {
      byMonth: [],
      byQuarter: [],
      byYear: [],
      byAssignee: []
    },
    trendGrpahLoading: true,
    barGrpahLoading: true,
    pieChartLoading: true,
    recordsLoading: true,
    pieChartOptions: undefined,
    trendGraphOptions: undefined,
    barGraphOptions: undefined,
    avgTimetoResolution: 0,
    sortBy: 'createdDate',
    sortOrder: 'desc',
    reportExpanded: '',
    actionAlertFormOpen: false,
    selectedAlertID: undefined,
    dictAvidPaths: new Set(),
    pieChartData: [],
    agingData: [],
    isPieChartExportDropdownOpen: false,
    isBarChartExportDropdownOpen: false,
    chartBarOptions: {
      dropdownOpen: false,
      orderBy: 'value',
      orderByValue: "descending",
      orderByValueOptions: [{ isEnabled: true, isChecked: false, label: 'Ascending' }, { isEnabled: true, isChecked: true, label: 'Descending' }],
    },
    hiddenProperties: [],
    AvidList: [],
    filteredAvidList: [],
    userId: undefined,
    customerInfoList: [],
  }
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.addEventListener('graphLoaded', () => this.setState({ trendGrpahLoading: false }))
    window.addEventListener('barGraphLoaded', () => this.setState({ barGrpahLoading: false }))
    this.state.assigneeChartRef = React.createRef();
    this.state.trendChartRef = React.createRef();
    this.getRecords();
    window.addEventListener('updateRecords', () => {
      this.setState({ actionAlertFormOpen: false }, () => {
        this.getRecords()
      });
    })
  }

  componentWillUnmount() {
    window.removeEventListener('graphLoaded', () => this.setState({ trendGrpahLoading: false }))
    window.removeEventListener('barGraphLoaded', () => this.setState({ barGrpahLoading: true }))
  }

  getRecords() {
    this.setState({ recordsLoading: true, pieChartLoading: true, barGrpahLoading: true }, () => {
      let data = { project: userData.getCurrentProject(), hier: userData.getFilters()['hier'] };
      const method = 'POST';
      HttpRequest.fetch('/scripts/reports/getAgingReport', { data, method })
        .then((res: actionAlert[]) => this.setState({ records: res, filteredRecords: res }, () => {
          getBulkCustomerInfo(userData.getCurrentProject(), getListOfIndividualSurveyIdsFromReport(res).join(',')).then((individualSurveysCustomerInfo) => {
            this.setState({ customerInfoList: individualSurveysCustomerInfo ? individualSurveysCustomerInfo : [] })
          })
          userData.getUserId().then((userId) => {
            res.map((alert) => {
              alert.severityLabel = (alert.severityLabel ? alert.severityLabel : 'Low');
              alert.severityColor = (alert.severityColor ? alert.severityColor : '#6c757d');
              return alert;
            })
            this.setState({ recordsLoading: false });

            // Group by status
            const recordsGroupedByStatus = _.groupBy(res, 'status');
            this.setState({
              pieChartData: [
                {
                  status: 'New',
                  alertCount: (recordsGroupedByStatus.New ? recordsGroupedByStatus.New.length : 0)
                },
                {
                  status: 'Pending',
                  alertCount: (recordsGroupedByStatus.Pending ? recordsGroupedByStatus.Pending.length : 0)
                }
              ]
            }, () => {
              this.setState({ pieChartLoading: false });
              this.updatePieChart('', (this.state.reportExpanded == 'trend' ? true : false));
            });

            // Group by age
            const recordsGroupedByAge = _.groupBy(res, 'age');
            let agingData = Object.entries(recordsGroupedByAge).map((group) => {
              return {
                age: group[0],
                alertCount: (group[1] ? group[1].length : 0)
              }
            });

            agingData = agingData.filter(group => parseInt(group.age) > 0);

            if (!this.state.userId) this.setState({ userId: userId });
            this.setState({ agingData: agingData }, () => {
              this.setState({ barGrpahLoading: false });
              this.updateBarGraph((this.state.reportExpanded == 'assignee' ? true : false));
            })
            this.updateFilteredRecords()
          })
        }));
    });
  }

  /**
   * Looks for parent avids until it gets the highest Hierarchy -> 'Banwide_0'
   * @param avid starting point
   */
  getRecordHierTrail(avid: string, trail: string[]) {
    if (avid != '-1') {
      const data = { currentHierarchy: avid, current_project: 'ABCU' }
      const method = 'POST';
      HttpRequest.fetch<Avid>('scripts/admin_action_alerts/get_avid', { data, method })
        .then((res) => {
          if (res.prevLink != '-1')
            trail.push(res.prevLink);
          return this.getRecordHierTrail(res.prevLink, trail);
        })
    } else {
      let dictAvidPaths = new Set(this.state.dictAvidPaths);
      const trace = trail.reverse();
      // trace.forEach((step, idx) => {
      //   if (!dictAvidPaths.has(step)) {

      //   }
      // });
      let hierPath: hierPath = {
        avid: trace[trace.length - 1],
        path: trace
      }
      dictAvidPaths.add(hierPath);
    }
  }

  updateFilterTags(filtersName: string, currentFilterStr: string, currentFilterList) {
    // TODO: Lift State Up
    let updatedFiltersList = []
    let filters = this.state.filters;
    currentFilterList.forEach((item) => {
      if (currentFilterStr != item)
        updatedFiltersList.push(item);
    });
    filters[filtersName].filteredList = (updatedFiltersList.length > 0 ? updatedFiltersList : filters[filtersName].defaultList);
    filters[filtersName].isFiltered = (updatedFiltersList.length != 0);
    this.setState({ filters: filters }, () => {
      this.updateFilteredRecords();
    });
  }

  updateTeamFilterTags(filtersName: string, currentFilterStr: string) {
    let filters = this.state.filters;
    let teamFilters = this.state.filters.teamFilters.defaultList;
    let updatedFiltersList = [];
    this.state.filters.teamFilters.filteredList.forEach((i) => {
      if (i != currentFilterStr) updatedFiltersList.push(i);
    })
    // if (updatedFiltersList.length == 0) updatedFiltersList.push('My Alerts')
    filters[filtersName].filteredList = (updatedFiltersList.length > 0 ? updatedFiltersList : filters[filtersName].defaultList);
    filters[filtersName].isFiltered = (updatedFiltersList.length != 0);
    this.setState({ filters: filters }, () => {
      this.updateFilteredRecords();
    });
  }


  generateSeries() {
    this.updatePieChart('', (this.state.reportExpanded == 'trend' ? true : false));
    this.updateBarGraph((this.state.reportExpanded == 'assignee' ? true : false));
  }

  updatePieChart(trendBy: string, expanded: boolean) {
    const pieData = this.state.pieChartData;
    const { series } = this.state;
    const data = pieData.map((item) => { return { 'name': item.status, 'y': item.alertCount } });
    let total = 0
    if (pieData.length > 0) {
      total = data.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);
    }
    const categories = pieData.map((item) => { return item.status });
    const trendGraphOptions = {
      exporting: {
        enabled: false,
        filename: 'new-vs-pending-action-alerts',
        chartOptions: {
          title: {
            text: `
            <b>New VS Pending Action Alerts</b><br/>
            `,
            align: 'center',
            style: {
              "fontWeight": 'bold'
            },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        }
      },
      colors: ['#FFAA00', '#0493FC'],
      chart: {
        events: {
          load: function () {
            setTimeout(function () {
              const graphLoaded = new CustomEvent('graphLoaded');
              window.dispatchEvent(graphLoaded);
            }, 1500);
          },
          beforePrint() {
            this.setTitle({
              text: `
            <b>New VS Pending Action Alerts</b><br/>
            `
            })
          },
          afterPrint() {
            this.setTitle({
              text: null,
              align: 'center',
            })
          }
        },
        height: (expanded ? '50%' : (9 / 16 * 100) + '%'), // 16:9 ratio
        type: 'pie'
      },
      title: {
        text: null,
        align: 'left',
        style: {
          "fontWeight": 'bold'
        }
      },
      legend: {
        enabled: true
      },
      credits: {
        enabled: false
      },
      yAxis: {
        visible: false,
      },
      tooltip: {
        formatter: function () {
          const complement = (this.point.name == 'New' ? 'Pending' : 'New');
          return '<b>' + this.point.name + ': ' + this.y + '</b><br><b>' + complement + ': ' + (total - this.y);
        }
      },
      series: [{
        name: 'New Vs Pending',
        type: 'pie',
        data: data
      }],
      xAxis: {
        categories: categories
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{y}'
          },
          showInLegend: true
        }
      }
    }
    this.setState({ trendGraphOptions: trendGraphOptions }, () => this.state.trendChartRef.current.chart.reflow());
  }

  updateBarGraph(expanded: boolean) {
    const { agingData } = this.state;
    const { series } = this.state;
    let filteredSeries = series.byAssignee;
    if (!expanded) {
      filteredSeries = filteredSeries.slice(0, 10);
    }

    const data = agingData.map((item) => { return item.alertCount });
    const categories = agingData.map((item) => { return item.age });
    const barGraphOptions = {
      exporting: {
        enabled: false,
        filename: 'action-alerts-aging',
        chartOptions: {
          title: {
            text: `
            <b>Action Alerts Aging</b><br/>
            `,
            align: 'center',
            style: {
              "fontWeight": 'bold'
            },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        }
      },
      chart: {
        events: {
          // load: function () {
          //   setTimeout(function () {
          //     const barGraphLoaded = new CustomEvent('barGraphLoaded');
          //     window.dispatchEvent(barGraphLoaded);
          //   }, 1500);
          // },
          beforePrint() {
            this.setTitle({
              text: `
            <b>Action Alerts Aging</b><br/>
            `
            })
          },
          afterPrint() {
            this.setTitle({
              text: null,
              align: 'center',
            })
          }
        },
        height: (expanded ? '50%' : (9 / 16 * 100) + '%') // 16:9 ratio
      },
      title: {
        text: null,
        align: 'left',
        style: {
          "fontWeight": 'bold'
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      yAxis: {
        visible: true,
        title: {
          text: 'Number of action alerts',
          align: 'high'
        },
      },
      tooltip: {
        formatter: function () {
          return '<b>' + this.x + ' days old: </b><br>' + this.y + ' action alerts';
        }
      },
      series: [{
        name: 'Aging of Action Alerts',
        type: 'bar',
        data: data,
        color: '#0493FC'
      }],
      xAxis: {
        categories: categories,
        title: {
          text: 'Age in Days'
        }
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{y}'
          }
        }
      }
    }
    this.setState({ barGraphOptions: barGraphOptions }, () => this.state.assigneeChartRef.current.chart.reflow());
  }

  updateBartChartOrder() {
    let orderedData = this.state.agingData;

    const { chartBarOptions } = this.state;

    const valueDesc = (a, b) => {
      if (a.alertCount > b.alertCount)
        return -1;
      if (a.alertCount < b.alertCount)
        return 1;
      return 0;
    }

    const valueAsc = (a, b) => {
      if (a.alertCount < b.alertCount)
        return -1;
      if (a.alertCount > b.alertCount)
        return 1;
      return 0;
    }

    const ageDesc = (a, b) => {
      if (parseInt(a.age) > parseInt(b.age))
        return -1;
      if (parseInt(a.age) < parseInt(b.age))
        return 1;
      return 0;
    }

    const ageAsc = (a, b) => {
      if (parseInt(a.age) < parseInt(b.age))
        return -1;
      if (parseInt(a.age) > parseInt(b.age))
        return 1;
      return 0;
    }

    if (chartBarOptions.orderBy == 'value') {
      if (chartBarOptions.orderByValue == 'ascending')
        orderedData.sort((a, b) => valueAsc(a, b));
      else orderedData.sort((a, b) => valueDesc(a, b));
    } else {
      if (chartBarOptions.orderByValue == 'ascending')
        orderedData.sort((a, b) => ageAsc(a, b));
      else orderedData.sort((a, b) => ageDesc(a, b))
    }

    this.setState({ agingData: orderedData }, () => this.updateBarGraph((this.state.reportExpanded == 'assignee' ? true : false)));
  }

  handleFiltersUpdate(filters: any) {
    // set avid list once
    if (this.state.AvidList.length == 0 && filters.AvidsList.length > 0) {
      this.setState({ AvidList: filters.AvidsList });
    }
    // set list of avid ids being filtered
    let filteredAvidIds = [];
    filters.AvidsList.forEach((avid) => {
      if (filters.filteredAvidIdList.includes(avid.id)) filteredAvidIds.push(avid.id);
    })
    this.setState({ filters: filters, filteredAvidList: filteredAvidIds }, () => {
      this.updatePieChart(filters.trendActiveFilter, (this.state.reportExpanded == 'trend' ? true : false));
      this.updateFilteredRecords();
    });
  }

  updateFilteredRecords() {
    const { filters, records, filteredAvidList } = this.state;
    let updatedRecords = [];
    records.forEach(record => {
      if (
        (filters.reasonFilters.filteredList.includes(record.actionItemReason) || record.actionItemReason == null) &&
        (filters.sourceFilters.filteredList.includes(record.src) || record.src == null) &&
        (filters.rootCauseFilters.filteredList.includes(record.rootCause) || record.rootCause == null) &&
        (filters.severityFilters.filteredList.includes(record.severityLabel) || record.severityLabel == null)
      ) {
        if (filteredAvidList.length == 0 || filteredAvidList.includes('myAlerts')) {
          if (record.assignedToId == this.state.userId) updatedRecords.push(record);
        } else {
          if (filteredAvidList.includes(record.avid)) updatedRecords.push(record);
        }
      }
    });
    this.setState({ filteredRecords: updatedRecords }, () => {
      this.generateSeries();
      if (updatedRecords.length > 0) { // Group by status
        const recordsGroupedByStatus = _.groupBy(updatedRecords, 'status');
        this.setState({
          pieChartData: [
            {
              status: 'New',
              alertCount: (recordsGroupedByStatus.New ? recordsGroupedByStatus.New.length : 0)
            },
            {
              status: 'Pending',
              alertCount: (recordsGroupedByStatus.Pending ? recordsGroupedByStatus.Pending.length : 0)
            }
          ]
        }, () => {
          this.setState({ pieChartLoading: false });
          this.updatePieChart('', (this.state.reportExpanded == 'trend' ? true : false));
        });
        // Group by age
        const recordsGroupedByAge = _.groupBy(updatedRecords, 'age');
        let agingData = Object.entries(recordsGroupedByAge).map((group) => {
          return {
            age: group[0],
            alertCount: (group[1] ? group[1].length : 0)
          }
        });

        agingData = agingData.filter(group => parseInt(group.age) > 0);

        this.setState({ agingData: agingData }, () => {
          this.setState({ barGrpahLoading: false });
          this.updateBarGraph((this.state.reportExpanded == 'assignee' ? true : false));
        })
      }
    });
  }

  expandReport(report: string, expand: boolean) {
    let { reportExpanded, filters } = this.state;
    reportExpanded = (expand ? report : '');
    this.setState({ reportExpanded: reportExpanded }, () => {
      if (report == 'trend') {
        this.updatePieChart('', (this.state.reportExpanded == 'trend' ? true : false));
      } else {
        this.updateBarGraph((this.state.reportExpanded == 'assignee' ? true : false));
      }
    });
  }

  /**
   * renderIdColumn
   */
  renderIdColumn(id, record) {
    let isEditMode = false;
    let alert = record;
    let customer = undefined
    const link = "#"
    return (
      <a href={link} className="id-wrapper" onClick={() => {
        this.setState({ selectedAlertID: id }, () => {
          this.setState({ actionAlertFormOpen: true });
        })
      }}>
        <FontAwesomeIcon icon="search" verticalAlign="initial" size="md" />
        <span>&nbsp;{id}</span>
      </a>
    )
  }

  /**
   * renderResolvedColumn
   */
  renderResolvedColumn(resolved: boolean) {
    let tag = '';
    if (resolved) {
      tag = 'Yes';
    } else tag = 'No';
    return (
      <p>{tag}</p>
    )
  }

  toggleModal(isOpen?: boolean) {
    const { actionAlertFormOpen } = this.state;
    this.setState({ actionAlertFormOpen: !actionAlertFormOpen });
  }

  toggleExportDropdown(dropdownName: string) {
    let partialState = {};
    let dropdownOpen: boolean = this.state[dropdownName];

    dropdownOpen = !dropdownOpen;

    partialState[dropdownName] = dropdownOpen;

    this.setState(partialState);
  }
  toggleBarChartOptions() {
    let { chartBarOptions } = this.state;
    chartBarOptions.dropdownOpen = !chartBarOptions.dropdownOpen;
    this.setState({ chartBarOptions: chartBarOptions });
  }

  toggleHiddenColumn(prop: string) {
    const { hiddenProperties } = this.state
    const indexOfProp = hiddenProperties.indexOf(prop)

    if (indexOfProp >= 0) {
      hiddenProperties.splice(indexOfProp, 1)
    } else {
      hiddenProperties.push(prop)
    }

    this.setState({ hiddenProperties })
  }


  isHiddenColumn(prop: string) {
    return this.state.hiddenProperties.indexOf(prop) >= 0
  }

  renderCustomerInfo(record: actionAlert): JSX.Element {
    const { customerInfoList } = this.state
    return (
      <span>{resolveCustomerNameOnReport(record, customerInfoList)}</span>
    )
  }

  renderAgeColumn(record: actionAlert): JSX.Element {
    return <span>{record.age}</span>
  }

  customSorting(sortBy: string, sortOrder: string, filteredRecords: actionAlert[]): actionAlert[] {
    if (sortBy === 'customerName') {
      return filteredRecords.sort((a, b) => compareCustomerNameOnReport(a, b, this.state.customerInfoList, sortOrder))
    }
    return []
  }


  render() {
    const { trendGraphOptions, pieChartLoading, barGrpahLoading, barGraphOptions, filteredRecords, recordsLoading, reportExpanded, chartBarOptions, filters, AvidList } = this.state;
    let trendReportExpanded = (reportExpanded == 'trend' ? true : false);
    let assigneeReportExpanded = (reportExpanded == 'assignee' ? true : false);

    let reasonFiltersList = [];
    let statusFiltersList = [];
    let sourceFiltersList = [];
    let rootCauseFiltersList = [];
    let severityFiltersList = [];
    let teamsFiltersList = [];

    if (filters && filters.reasonFilters && filters.reasonFilters.isFiltered) reasonFiltersList = filters.reasonFilters.filteredList;
    if (filters && filters.sourceFilters && filters.sourceFilters.isFiltered) sourceFiltersList = filters.sourceFilters.filteredList;
    if (filters && filters.rootCauseFilters && filters.rootCauseFilters.isFiltered) rootCauseFiltersList = filters.rootCauseFilters.filteredList;
    if (filters && filters.severityFilters && filters.severityFilters.isFiltered) severityFiltersList = filters.severityFilters.filteredList;
    if (filters && filters.teamFilters && filters.teamFilters.isFiltered) teamsFiltersList = filters.teamFilters.filteredList;

    return (
      <>
        <div className="row">
          <div className="col-sm-2">
            <ReportsFilersBar
              title='hello world filters bar'
              handler={(filters) => this.handleFiltersUpdate(filters)}
              reasonFilters={reasonFiltersList}
              sourceFilters={sourceFiltersList}
              rootCauseFilters={rootCauseFiltersList}
              severityFilters={severityFiltersList}
              teamFilters={teamsFiltersList}
            />
          </div>
          <div className="col-sm-10">
            <div className="row">
              {reasonFiltersList.map((filterString, idx) => {
                return (
                  <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                    this.updateFilterTags('reasonFilters', filterString, reasonFiltersList);
                  }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                );
              })}
              {sourceFiltersList.map((filterString, idx) => {
                return (
                  <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                    this.updateFilterTags('sourceFilters', filterString, sourceFiltersList);
                  }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                );
              })}
              {rootCauseFiltersList.map((filterString, idx) => {
                return (
                  <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                    this.updateFilterTags('rootCauseFilters', filterString, rootCauseFiltersList);
                  }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                );
              })}
              {severityFiltersList.map((filterString, idx) => {
                return (
                  <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                    this.updateFilterTags('severityFilters', filterString, severityFiltersList);
                  }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                );
              })}
              {teamsFiltersList.map((filterString, idx) => {
                const currentAvid = AvidList.find(el => el.text === filterString);
                const parentAvid = AvidList.find(el => el.id === currentAvid.prevLink);
                if ((parentAvid && !teamsFiltersList.includes(parentAvid.text) || !parentAvid)) {
                  return (
                    <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                      this.updateTeamFilterTags('teamFilters', filterString);
                    }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                  );
                }
              })}
            </div>
            <div className="row">
              <div className={(reportExpanded.length > 0 ? (reportExpanded == 'trend' ? 'col-sm-12' : 'd-none') : "col-sm-6 border-right")}>
                <header className="d-flex justify-content-between">
                  <h4>New vs Pending Action Alerts</h4>
                  <span className="d-flex justify-content-around chart-report-controls" style={{ flexBasis: '10%' }}>
                    <ExportChart isDropdownOpen={this.state.isPieChartExportDropdownOpen} toggle={() => this.toggleExportDropdown('isPieChartExportDropdownOpen')} chartRef={this.state.trendChartRef} title='Average Days to Resolution' subtitle={''} />
                    <div><i className={(trendReportExpanded ? "fas fa-compress fa-lg" : "fas fa-expand fa-lg")} onClick={() => this.expandReport('trend', (trendReportExpanded ? false : true))}></i></div>
                  </span>
                </header>
                <div className='center-align'>
                  <div className={(pieChartLoading ? "spinner-border" : "d-none")} role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className={(pieChartLoading ? "d-none" : "")}>
                    <div className={(filteredRecords.length > 0 && recordsLoading === false) ? "d-block" : "d-none"}>
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={trendGraphOptions}
                        allowChartUpdate={true}
                        ref={this.state.trendChartRef}
                      />
                    </div>
                    <div className={(filteredRecords.length > 0 && recordsLoading === false) ? "d-none" : "d-block"} style={{ marginTop: '25%' }}>
                      <div className="alert alert-warning" role="alert">
                        <FontAwesomeIcon icon="sticky-note" verticalAlign="initial" size="md" />
                        <span>&nbsp;No data found for the current filters.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={(reportExpanded.length > 0 ? (reportExpanded == 'assignee' ? 'col-sm-12' : 'd-none') : "col-sm-6")}>
                <header className="d-flex justify-content-between">
                  <h4>Action Alerts Aging</h4>
                  <span className="d-flex justify-content-around chart-report-controls" style={{ flexBasis: '15%' }}>
                    <ExportChart isDropdownOpen={this.state.isBarChartExportDropdownOpen} toggle={() => this.toggleExportDropdown('isBarChartExportDropdownOpen')} chartRef={this.state.assigneeChartRef} title='Average Days to Resolution' subtitle={''} />
                    {/*<i className="fas fa-pencil-alt"></i>*/}
                    <Dropdown direction="left" isOpen={chartBarOptions.dropdownOpen} toggle={() => this.toggleBarChartOptions()}>
                      <DropdownToggle
                        tag="i"
                        data-toggle="dropdown"
                        aria-expanded={chartBarOptions.dropdownOpen}
                        className="fas fa-pencil-alt fa-lg"
                      >
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem header>Order by value</DropdownItem>
                        <RadioGroup
                          onChange={(order) => {
                            let { chartBarOptions } = this.state;
                            const data = order.toLowerCase();
                            chartBarOptions.orderByValue = (data == 'ascending' ? data : 'descending');
                            let updatedOptions = []
                            chartBarOptions.orderByValueOptions.forEach((item) => {
                              updatedOptions.push({ label: item.label, isChecked: (order == item.label), isEnabled: true });
                            });
                            chartBarOptions.orderByValueOptions = updatedOptions;
                            chartBarOptions.orderBy = "value";
                            this.setState({ chartBarOptions: chartBarOptions }, () => this.updateBartChartOrder());
                          }}
                          options={chartBarOptions.orderByValueOptions}
                          optionClass='dropdown-item'
                        >
                        </RadioGroup>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem header>Order by assignee</DropdownItem>
                        <RadioGroup
                          onChange={(order) => {
                            let { chartBarOptions } = this.state;
                            const data = order.toLowerCase();
                            chartBarOptions.orderByValue = (data == 'ascending' ? data : 'descending');
                            let updatedOptions = []
                            chartBarOptions.orderByValueOptions.forEach((item) => {
                              updatedOptions.push({ label: item.label, isChecked: (order == item.label), isEnabled: true });
                            });
                            chartBarOptions.orderByValueOptions = updatedOptions;
                            chartBarOptions.orderBy = "label";
                            this.setState({ chartBarOptions: chartBarOptions }, () => this.updateBartChartOrder());
                          }}
                          options={chartBarOptions.orderByValueOptions}
                          optionClass='dropdown-item'
                        >
                        </RadioGroup>
                      </DropdownMenu>
                    </Dropdown>
                    <div><i className={(assigneeReportExpanded ? "fas fa-compress fa-lg" : "fas fa-expand fa-lg")} onClick={() => this.expandReport('assignee', (assigneeReportExpanded ? false : true))}></i></div>
                  </span>
                </header>
                <div className='center-align'>
                  <div className={(barGrpahLoading ? "spinner-border" : "d-none")} role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className={(barGrpahLoading ? "d-none" : "")}>
                    <div className={(filteredRecords.length > 0 && recordsLoading === false) ? "d-block" : "d-none"}>
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={barGraphOptions}
                        allowChartUpdate={true}
                        ref={this.state.assigneeChartRef}
                      />
                    </div>
                    <div className={(filteredRecords.length > 0 && recordsLoading === false) ? "d-none" : "d-block"} style={{ marginTop: '25%' }}>
                      <div className="alert alert-warning" role="alert">
                        <FontAwesomeIcon icon="sticky-note" verticalAlign="initial" size="md" />
                        <span>&nbsp;No data found for the current filters.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={(reportExpanded.length > 0 ? 'd-none' : "col-sm-12")}>
                <div className="card">
                  <div className="bg-white table-border-bottom sticky-top card-body" style={{ fontSize: '1rem' }}>
                    <section className="mt-2 d-md-flex justify-content-end">
                      <Popover btnText="Fields">
                        <section style={{ fontSize: '1rem', minWidth: 150, maxHeight: '250px', overflowY: 'scroll' }}>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('reason')} onChange={() => this.toggleHiddenColumn('reason')} />
                              <span>&nbsp;Reason for Alert</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('status')} onChange={() => this.toggleHiddenColumn('status')} />
                              <span>&nbsp;Status</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('rootCause')} onChange={() => this.toggleHiddenColumn('rootCause')} />
                              <span>&nbsp;Root Cause</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('severity')} onChange={() => this.toggleHiddenColumn('severity')} />
                              <span>&nbsp;Severity</span>
                            </Label>
                          </FormGroup>
                        </section>
                      </Popover>
                    </section>
                  </div>
                  <div className="card-body">
                    {recordsLoading &&
                      <div className="center-align">
                        <div className={(pieChartLoading ? "spinner-border" : "d-none")} role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    }
                    {filteredRecords.length == 0 && recordsLoading == false &&
                      <div className="alert alert-warning" role="alert">
                        <FontAwesomeIcon icon="sticky-note" verticalAlign="initial" size="md" />
                        <span>&nbsp;No data found for the current filters.</span>
                      </div>
                    }
                    {filteredRecords.length > 0 &&
                      <DataGrid<actionAlert>
                        sortBy={this.state.sortBy}
                        sortOrder={this.state.sortOrder}
                        onSortChange={(sortBy, sortOrder) => this.setState({ sortBy, sortOrder }, () => {
                          const updatedRecords = this.customSorting(
                            sortBy,
                            sortOrder,
                            filteredRecords
                          );
                          if (updatedRecords.length > 0)
                            this.setState({ filteredRecords: updatedRecords });
                        })}
                        records={filteredRecords}
                        columns={[
                          { header: 'ID', property: 'id', render: (record) => this.renderIdColumn(record.id, record) },
                          { header: 'Reason for Alert', property: "actionItemReason", hidden: this.isHiddenColumn('reason') },
                          { header: 'Assignee', property: 'Username' },
                          { header: 'Customer Name', property: 'customerName', render: (record) => this.renderCustomerInfo(record) },
                          { header: 'Status', property: 'status', hidden: this.isHiddenColumn('status') },
                          { header: 'Source', property: 'src' },
                          { header: 'Root Cause', property: 'rootCause', hidden: this.isHiddenColumn('rootCause') },
                          { header: 'Age', property: 'ageAsNumber', render: (record) => this.renderAgeColumn(record) },
                          {
                            header: 'Severity', property: 'severityLabel', render: (record) => {
                              return (
                                <span style={{ color: record.severityColor }}>{record.severityLabel}</span>
                              );
                            }, hidden: this.isHiddenColumn('severity')
                          }
                        ]}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ActionAlertFormContainer
          customer={{ name: 'John Doe', email: '', phoneNumber: '888-888-888' }}
          alertID={this.state.selectedAlertID}
          isOpen={this.state.actionAlertFormOpen}
          toggleModal={(isOpen) => this.toggleModal(isOpen)}
        />
      </>
    );
  }
}
